"use strict";
const INTERVAL_DURATION = 1000;
const Interval = (component) => {
    return class extends component {
        constructor(props) {
            super(props);
            this.state = {
                interval: null,
            };
        }
        componentWillMount() {
            this.createInterval(this.props);
        }
        componentWillReceiveProps(nextProps) {
            if (!this.state.interval && nextProps.active) {
                this.createInterval(nextProps);
            }
            if (!nextProps.active) {
                this.clearInterval();
            }
        }
        componentWillUnmount() {
            this.clearInterval();
        }
        createInterval(props) {
            if ((!this.state || !this.state.interval) && props.active) {
                const interval = setInterval(this.forceUpdate.bind(this), INTERVAL_DURATION);
                this.setState({ interval });
            }
        }
        clearInterval() {
            if (this.state.interval) {
                clearInterval(this.state.interval);
                this.setState({ interval: null });
            }
        }
    }
    ;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Interval;



/** WEBPACK FOOTER **
 ** ./src/components/Interval.tsx
 **/